import { render, staticRenderFns } from "./SocietyTable.vue?vue&type=template&id=bd849704&scoped=true"
import script from "./SocietyTable.vue?vue&type=script&lang=js"
export * from "./SocietyTable.vue?vue&type=script&lang=js"
import style0 from "./SocietyTable.vue?vue&type=style&index=0&id=bd849704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd849704",
  null
  
)

export default component.exports